import { render, staticRenderFns } from "./documentscertificates.vue?vue&type=template&id=2e77ea54&scoped=true&"
import script from "./documentscertificates.vue?vue&type=script&lang=js&"
export * from "./documentscertificates.vue?vue&type=script&lang=js&"
import style0 from "./documentscertificates.vue?vue&type=style&index=0&id=2e77ea54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e77ea54",
  null
  
)

export default component.exports